/**=========================================================
 * Module: reviewer.js
 * Reviewer Controller
 =========================================================*/

 App.controller('ReviewerController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$filter', 'ngDialog', 'toaster',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter, ngDialog, toaster) {
    "use strict";

    $scope.type = 'translation';
    $scope.filter = '';

    $scope.data = [];

    $scope.page = {
            title: 'labels.ASSIGNREVIEWER',
            subTitle: ''
        };

    $scope.pop = function(type, title, text) {
        toaster.pop(type, title, text, 0, 'trustedHtml');
    };

    $scope.assignReviewer = function(rid){
        ngDialog.openConfirm({
            template: '/app/views/entities/confirm.html',
            className: 'ngdialog-theme-default',
            scope: $scope
          }).then(function (value) {
              $scope.translation.action = 'assignReviewer'
              $scope.translation.newReviewer = rid
              D.save('translation', $scope.translation).then(function(response){
                $scope.translation = response
                
              }).catch(function(err){
                if(err.data && err.data.msg && err.data.msg.indexOf('noReviewHasBeenDone')){
                    $scope.pop('error', $filter('translate')('labels.CANTSKIPREVIEWIFNOREVIEWDONE'));
                }
              })
          })
    }

    $scope.initialized = false;
    $scope.watchActivated = false;
    $scope.init = function(){

    if($rootScope.user.id && ($rootScope.user.groupType=='ADMIN' || $rootScope.user.groupType=='CLIENT')){
        $scope.initialized = true;

        D.load('translation', $state.params.filter).then(function(response){
            $scope.translation = response
            
            D.load('project', $scope.translation.project).then(function(response){
                $scope.project = response
                
                $scope.page.subTitle = $filter('translate')('fields.PROJECT') + ': ' + $scope.project.code + ' / ' + $filter('translate')('fields.LANGUAGE') + ': ' + $filter('translate')('enums.language.' + $scope.translation.destination)

                D.query('account', { group: $scope.project.group, customRole: 'REVIEWER', _reviewLanguage: $scope.translation.destination }, { cache: false }).then(function(response){
                    $scope.reviewers = response
                }).catch(console.error)
            }).catch(console.error)
            
        }).catch(console.error)

    } else {
        if(!$scope.watchActivated){
            $scope.watchActivated = true;
            $rootScope.$watch('user.id', function(){
                if(!$scope.initialized){
                    $scope.init();
                }
            });
        }
    }
    }

    $scope.init();

    $scope.$on('$destroy', function iVeBeenDismissed() {
        // say goodbye to your controller here
        // release resources, cancel request...
        $scope.load = function() { };
    });
}]);
